import { render, staticRenderFns } from "./GameCardTitle.vue?vue&type=template&id=6ecd8ae8"
import script from "./GameCardTitle.vue?vue&type=script&lang=js"
export * from "./GameCardTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports